module.exports = __webpack_public_path__ + "img/reg_experts.fbd881b9.png";